import { render } from "./Marquee.vue?vue&type=template&id=25d8d989&ts=true"
import script from "./Marquee.vue?vue&type=script&lang=ts"
export * from "./Marquee.vue?vue&type=script&lang=ts"

import "./Marquee.vue?vue&type=style&index=0&id=25d8d989&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__